import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import AnalyticsGateway from '../lib/AnalyticsGateway';
import { find } from 'lodash';

const ComparableSortBy = ({
  options,
  disabled,
  onChange,
  analyticsPage,
  comparables,
  label = <Typography variant="fontWeight600" mb={0.5} sx={{ display: 'block' }}>Sort by</Typography>,
}) => {
  const onSort = (_, data) => {
    const oldValue = comparables.sortBy || 'default';
    const newValue = data.value;
    if (newValue !== oldValue) {
      onChange(newValue);
      AnalyticsGateway.sendEvent({
        eventName: 'Change Sort Order',
        properties: [
          { label: 'Page', value: analyticsPage },
          {
            label: 'Object Context',
            value: find(options, (item) => item.value === newValue)?.text
          }
        ]
      });
    }
  };

  const selectedValue = comparables.sortBy || 'default';

  return (
      <Form.Select
          key={selectedValue}
          width={4}
          className="sort-by"
          label={label}
          value={selectedValue}
          options={options}
          disabled={disabled}
          onChange={onSort}
      />
  );
};

ComparableSortBy.propTypes = {
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  analyticsPage: PropTypes.string.isRequired,
  comparables: PropTypes.object.isRequired,
  label: PropTypes.element,
};

export default ComparableSortBy;
